import React, { useState } from 'react';
import TopNav from '../../../Components/TopNav';
import Navbar from '../../../Components/Navbar';
import DropdownNav from '../../../Components/DropdownNav';
import './about.css'
import Footer from '../../../Components/Footer';
import Example from '../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const Autonomy = () => {
  const [toggle, setToggle] = useState(1)
  const [isOpen, setIsOpen] = useState(false)
  const [joint, setJoint] = useState(false)
  const [hons, setHons] = useState(false)
  const [princpal, setPrincpal] = useState(false)
  const [fifth, setFifth] = useState(false)
  const [Sixth, setSixth] = useState(false)
  const [sev, setSev] = useState(false)
  const [eigth, setEigth] = useState(false)
  const [nine, setNine] = useState(false)
  const [tenth, setTenth] = useState(false)
  const [eleven, setEleven] = useState(false)
  const [tweal, setTweal] = useState(false)
  const [theten, setTheten] = useState(false)
  const [fourten, setFourten] = useState(false)
  const [fiftens, setFiftens] = useState(false)


  function updateToogle(id) {
    setToggle(id)
  }


  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='init-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      <div className='Measi-details'>
        <div className='measi-header'>
          <h2>Infrastructure → Autonomy</h2>
          <p>The New College infrastructure is one of the biggest & best in Tamil Nadu.</p>
        </div>

        <div className='tab-main'>
          <ul className='tab-details'>
            <li className={toggle === 1 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(1)}>Declaration</li>
            <li className={toggle === 2 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(2)}>Statutory Committee</li>
            <li className={toggle === 3 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(3)}>Non – Statutory Committees</li>
          </ul>


          {/* Tab One Details */}

          <div className={toggle === 1 ? "show-tab-content" : 'tab-content'}>
            <h1>DECLARATION</h1>
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}

              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/images/DECLARATION-1.jpg' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>DECLARATION</h3>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Second Tab Details */}

          <div className={toggle === 2 ? "show-tab-content" : 'tab-content'}>
            <h1>Commitee Under the UGC Act</h1>
            <button onClick={() => setIsOpen(e => !e)} className='tab-open-btn'>✠ Governing Body </button>
            {
              isOpen && (
                <div >
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Name of the Members</th>
                      <th>Designation</th>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>MEMBERS OF THE MANAGEMENT</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>1</td>
                      <td>H.H. Nawab Mohammed Abdul Ali Azimjah, Prince of Arcot (Chairman)</td>
                      <td>Chairman, <br></br>
                        Managing Committee</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Mr. Elias Sait</td>
                      <td>Hon. Secretary & Correspondent, <br></br>
                        Managing Committee</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Mr. M Najmuddin</td>
                      <td>Hon. Treasurer <br></br>
                        Managing Committee</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Mr. M. Razzack</td>
                      <td>Member
                        Managing Committee</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Mr. M. Nazar Mohamed
                        Educationist</td>
                      <td>Assistant Treasurer <br></br>
                        Managing Committee</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>PRINCIPAL (Ex-Officio)</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Dr. S. Basheer Ahamed</td>
                      <td>Principal</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>SENIOR TEACHERS OF THE COLLEGE</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Mr. S. A. Sheik Mohamed</td>
                      <td>Associate Professor of English & <br></br> Vice-Principal (Academic)</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Dr. V. Kamal Nasir</td>
                      <td>Associate Professor of Mathematics & <br></br> Vice-Principal (Administration)</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>EDUCATIONALIST / INDUSTRIALIST</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Mr. Ashfaque Ahmad Mecca</td>
                      <td>Industrialist</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>UGC NOMINEE</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Prof. Anand Mohan</td>
                      <td>Registrar,
                        Dayalbagh Educational <br></br> Institute(Deemed University) Dayalbagh.</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>STATE GOVERNMENT NOMINEE</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Dr. R.Ravanan</td>
                      <td>Regional Joint Director,
                        Office of the Regional Joint <br></br> Director of Collegiate Education, Chennai.</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>UNIVERSITY NOMINEE</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Dr. S. Manivasakan</td>
                      <td>Professor & Director,
                        UGC- Centre for South & <br></br> Southeast Asian Studies University of Madras Chepauk Campus, Chennai.</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>SPECIAL INVITEES</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>Prof. A.R. Abdul Lathif</td>
                      <td>Controller of Examinations</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>Dr. Mohammed Ibrahim Naveed</td>
                      <td>Associate Professor of Zoology & <br></br> Coordinator for Projects and Grants</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td>Dr. Anvar Sadhath V</td>
                      <td>Director, IQAC</td>
                    </tr>
                  </table>
                </div>

              )
            }


            <button onClick={() => setJoint(e => !e)} className='tab-open-btn'>✠ Academic Council</button>
            {
              joint && (
                <div >
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Name & Designation</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Dr. S. Basheer Ahamed
                        Principal (Chairman)</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>Experts Nominated by the Governing Body</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Mr. Elias Sait
                        Chartered Accountant</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Mr. M. Najmuddin
                        Industrialist</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Mr. M. Razzack
                        Educationist</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Mr. M. Nazar Mohamed
                        Educationist</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Mr. Ashfaque Ahmad Mecca
                        Industrialist</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Dr. T Mohamed Ilyas <br></br>
                        Principal <br></br>
                        Islamiah College,Vaniyambadi</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Dr. D.V. Chandrakumar <br></br>
                        Professor and Head <br></br>
                        Department of Library & Information Science <br></br>
                        University of Madras</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Dr. R. Azhagarasan <br></br>
                        Professor, <br></br>
                        Department of English, <br></br>
                        University of Madras</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Dr. A. J. Vanisree <br></br>
                        Professor, <br></br>
                        Department of Biochemistry, <br></br>
                        University of Madras</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>Four Senior Teachers of the College</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Prof. S. A. Sheik Mohamed  <br></br>
                        Associate Professor of English, & Vice Principal (Academic)</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Dr. V. Kamal Nasir <br></br>
                        Associate Professor of Mathematics & <br></br>
                        Vice Principal (Administration)</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>Prof. A. R. Abdul Lathif <br></br>
                        Controller of Examinations</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>Dr. Anvar Sadhath Valiyaparambath <br></br>
                        Associate Professor of English & Director, IQAC</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>Four Senior Teachers of the College</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td>Prof. S. Syed Sarmadh Ahmed, Associate Professor, Head i/c, <br></br>
                        Department of English</td>
                    </tr>
                    <tr>
                      <td>16</td>
                      <td>Dr. S. Mohamed Abdul Razak <br></br>
                        Head, Department of Tamil & Dean of Arts</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td>Dr. N.M. Ahamed Ibrahim <br></br>
                        Head, Department of Arabic</td>
                    </tr>
                    <tr>
                      <td>18</td>
                      <td>Dr. S. Shafivulla <br></br>
                        Associate Professor & Head <br></br>
                        Department of Hindi</td>
                    </tr>
                    <tr>
                      <td>19</td>
                      <td>Dr. M.S.A. Jafarullah Khan <br></br>
                        Associate Professor & Head <br></br>
                        Department of Historical Studies</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td>Dr. S. Kareemulla Basha <br></br>
                        Associate Professor & Head <br></br>
                        Department of Economic</td>
                    </tr>
                    <tr>
                      <td>21</td>
                      <td>Dr. Geetha Krishnan <br></br>
                        Associate Professor & Head <br></br>
                        Department of Sociology</td>
                    </tr>
                    <tr>
                      <td>22</td>
                      <td>Dr. S. Syed Rafiq Ahmed <br></br>
                        Head, Department of Commerce & Bursar</td>
                    </tr>
                    <tr>
                      <td>23</td>
                      <td>Prof. K.S. Mohamed Akmal <br></br>
                        Head, Department of Corp. Sec. & Dean of Commerce</td>
                    </tr>
                    <tr>
                      <td>24</td>
                      <td>Prof. A. Fiaz Ahamed <br></br>
                        Associate Professor & Head <br></br>
                        Department of Mathematics</td>
                    </tr>
                    <tr>
                      <td>25</td>
                      <td>Capt. M. Anees Ahmed <br></br>
                        Associate Professor & Head <br></br>
                        Department of Physics</td>
                    </tr>
                    <tr>
                      <td>26</td>
                      <td>Dr. M.A. Mohamed Musthafa <br></br>
                        Head, Department of Chemistry & Dean of Science</td>
                    </tr>
                    <tr>
                      <td>27</td>
                      <td>Dr. M. Shareef Khan <br></br>
                        Associate Professor & Head <br></br>
                        Department of Plant Biology & Plant Biotechnology</td>
                    </tr>
                    <tr>
                      <td>28</td>
                      <td>Dr. M. Asrar Sheriff <br></br>
                        Associate Professor & Head, <br></br>
                        Department of Zoology</td>
                    </tr>
                    <tr>
                      <td>29</td>
                      <td>Dr. P. Hakkim Divan Mohideen <br></br>
                        Assistant Professor & Head, <br></br>
                        Department of Computer Science</td>
                    </tr>
                    <tr>
                      <td>30</td>
                      <td>Dr. A.K. Mohamed Ali <br></br>
                        Associate Professor & Head i/c, Dep. of English (Shift - II)</td>
                    </tr>
                    <tr>
                      <td>31</td>
                      <td>Dr. S. Tameem Sharief <br></br>
                        Assistant Professor & Head <br></br>
                        Department of Commerce (Shift – II)</td>
                    </tr>
                    <tr>
                      <td>32</td>
                      <td>Dr. J Sulaiman <br></br>
                        Assistant Professor & Head <br></br>
                        Department of Accounting & Finance (Shift – II)</td>
                    </tr>
                    <tr>
                      <td>33</td>
                      <td>Mr. K. Syed Mohamed Bukari <br></br>
                        Assistant Professor & Head <br></br>
                        Department of Information Technology (Shift – II)</td>
                    </tr>
                    <tr>
                      <td>34</td>
                      <td>Mr. A.S. Mohamed Hamsa <br></br>
                        Assistant Professor & Head <br></br>
                        Dep. of Computer Sci. (Shift – II)</td>
                    </tr>
                    <tr>
                      <td>35</td>
                      <td>Mr. M.I. Seyadu Umar Farook, <br></br> Asst.Prof & Head Dep. of Computer Appl. (Shift – II)</td>
                    </tr>
                    <tr>
                      <td>36</td>
                      <td>Mr. F. Mohamed Ilyas
                        Assistant Professor & Head Department of <br></br> Information Systems & Management (Shift-II)</td>
                    </tr>
                    <tr>
                      <td>37</td>
                      <td>Mr. R. Vijayakumar <br></br>
                        Assistant Professor & Head <br></br>
                        Department of Business <br></br>
                        Administration ( Shift – II )</td>
                    </tr>
                    <tr>
                      <td>38</td>
                      <td>Dr. V. Gunasekaran <br></br>
                        Assistant Professor & Head<br></br>
                        Department of Bank <br></br>
                        Management (Shift – II )</td>
                    </tr>
                    <tr>
                      <td>39</td>
                      <td>Mr. M.A. Imran Musthafa <br></br>
                        Assistant Professor & Head <br></br>
                        Department of Biotechnology <br></br>
                        (Shift – II)</td>
                    </tr>
                    <tr>
                      <td>40</td>
                      <td>Dr. U. Mahaboob Basha <br></br>
                        Director of Physical Education</td>
                    </tr>
                    <tr>
                      <td>41</td>
                      <td>Mr. S.M. Mohamed Lukman <br></br>
                        Librarian</td>
                    </tr>
                    <tr>
                      <td>42</td>
                      <td>Ms. J. Jeevitha
                        Assistant Professor & Head i/c Department of Criminology <br></br> and Police Administration (Shift - II)</td>
                    </tr>
                    <tr>
                      <td>43</td>
                      <td>Dr. A. P. Sankara Narayanan
                        Assistant Professor & Head i/c Department of Defence <br></br> and Strategic Studies (Shift - II)</td>
                    </tr>
                    <tr>
                      <td>44</td>
                      <td>Mr. J. A. Jebastian
                        Assistant Professor & Head i/c  <br></br>Department of Electronic Media (Shift - II)</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>Special Invitees</td>
                    </tr>


                    <tr>
                      <td>45</td>
                      <td>Dr. M. Gulam Mohamed <br></br>
                        Associate Professor of Physics & Dean of Research</td>
                    </tr>
                    <tr>
                      <td>46</td>
                      <td>Dr. A. Hyder Ali <br></br>
                        Assistant Professor of Zoology & Deputy Warden</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>Member Secretary</td>
                    </tr>


                    <tr>
                      <td>47</td>
                      <td>Dr. Mohammed Ibrahim Naveed <br></br>
                        Associate Professor of Zoology & Coordinator for Projects and Grants</td>
                    </tr>

                  </table>
                </div>
              )
            }

            <button onClick={() => setHons(e => !e)} className='tab-open-btn'>✠ Finance Committee</button>
            {
              hons && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>Members of the Finance Committee</h1>
                  <div className='tab-para'>
                    <p>⬣ Mr. Elias Sait, Hon. Secretary & Correspondent, Managing Committee</p>
                    <p>⬣ Mr. M Najmuddin, Hon. Treasurer, Managing Committee</p>
                    <p>⬣ Mr. M. Razzack, Vice President, Managing Committee</p>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal & Chairman of Finance Committee</p>
                    <p>
                      ⬣ Prof. S. A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>
                      ⬣ Dr. V. Kamal Nasir, Vice Principal (Administration)</p>
                    <p>
                      ⬣ Prof. A.R. Abdul Lathif, Controller of Examinations</p>
                    <p>
                      ⬣ Dr. S. Syed Rafiq Ahmed, Bursar</p>
                    <p>
                      ⬣ Dr. Mohammed Ibrahim Naveed, Associate Professor of Zoology & Coordinator, UGC Grants</p>
                    <p>⬣  Dr. Anvar Sadhath V Associate Professor of English & Director, IQAC</p>
                  </div>
                </div>
              )
            }


          </div>

          {/* Third Tab Details */}

          <div className={toggle === 3 ? "show-tab-content" : 'tab-content'}>
            <h1>Commitee Under the UGC Act</h1>
            <button onClick={() => setIsOpen(e => !e)} className='tab-open-btn'>✠ ANTI RAGGING COMMITTEE </button>
            {
              isOpen && (
                <div >
                  <h2>ANTI RAGGING COMMITTEE <br></br>
                    2022-2023</h2>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Name & Designation</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>Dr. S. Basheer Ahamed <br></br>
                        Principal (Chairman)</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Mr. S. A. Sheik Mohamed <br></br>
                        Vice Principal (Academics)</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Dr. V. Kamal Nasir <br></br>
                        Vice Principal (Administration)</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Mr. A. R. Abdul Lathif <br></br>
                        Controller of Examinations</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Dr. Anvar Sadhath Valiyaparambath <br></br>
                        Director - IQAC</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Dr. A. Hyder Ali <br></br>
                        Deputy Warden</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Dr. S. Kareemullah Basha <br></br>
                        Dean of Humanities</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Mr. A. Sarmadh Ahmed <br></br>
                        President - New College Staff Association</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Mr. K. S. Md. Akmal <br></br>
                        Dean of Commerce and Management</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Dr. M. A. Mohamed Musthafa <br></br>
                        Dean of Physical and Chemical Science</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Dr. S. Mohamed Abdul Razak <br></br>
                        Dean of Languages and literature</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Dr. M. Asrar Sheriff <br></br>
                        Dean of Biological Science</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>Mr. A. Fiaz Ahamed <br></br>
                        Dean of Computational Science</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>Dr. M. Gulam Mohamed <br></br>
                        Dean - Research</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td>Dr. N.M. Ahamed Ibrahim <br></br>
                        Associate professor of Arabic</td>
                    </tr>
                    <tr>
                      <td>16</td>
                      <td>Dr. M. S. A. Jafarullah Khan <br></br>
                        Head & Associate Professor of History</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td>Mr. A. Khaja Mohideen <br></br>
                        Vice President - Student's Council <br></br>
                        Shift - I</td>
                    </tr>
                    <tr>
                      <td>18</td>
                      <td>Mr. A.S. Mohamed Hamsa <br></br>
                        Vice President - Student's Council<br></br>
                        Shift - II</td>
                    </tr>
                    <tr>
                      <td>19</td>
                      <td>Dr. Syed Mohmammed Mujaheer <br></br>
                        NSS, Programme Officer</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td>Dr. N. Md. Azmathullah <br></br>
                        NCC Officer</td>
                    </tr>
                    <tr>
                      <td>21</td>
                      <td>Mr. M. H. Rasool Mohideen <br></br>
                        Office Superintendent</td>
                    </tr>
                    <tr>
                      <td>22</td>
                      <td>Student Union Office Bearers</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>For complaints and suggestions contact
                        principal@thenewcollege.edu.in</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}><a href='https://thenewcollege.edu.in/about_us/pdf/anti-ragging-cell-scan-2020-21.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>Minutes of the Meeting</a></td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setJoint(e => !e)} className='tab-open-btn'>✠ COMPLAINT COMMITTEE</button>
            {
              joint && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF INTERNAL COMPLAINT COMMITTEE</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. J. Askar Ali, Associate Professor of Chemistry</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Dr. G. Shaik Abdul Wahab, Associate Professor of English</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Dr. Abdul Raheem, Associate Professor of EconomicsMr. M. Razzack, Vice President, Managing Committee</p>
                    <p>⬣ Dr. A. Rasheeth, Associate Professor of Chemistry</p>
                    <p>
                      ⬣ Dr. F. Asiya Khilji, Assistant Professor of Business Administration</p>
                    <p>
                      ⬣ Ms. J. Jeevitha, Assistant Professor of Criminology</p>
                    <br></br>
                    <br></br>
                    <h3>*Formerly called as Prevention of Sexual Harassment Cell.</h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/minutes-internal-comp.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }

            <button onClick={() => setHons(e => !e)} className='tab-open-btn'>✠ SC / ST CELL</button>
            {
              hons && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF SC / ST CELL</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Dr. K. Asokan, Assistant Professor of Tamil</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Prof. S.A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>⬣ Dr. V. Kamal Nasir, Vice Principal (Admin)</p>
                    <p>
                      ⬣ Dr. Anvar Sadhath VP, Director, IQAC</p>
                    <p>
                      ⬣ Dr. A. Hyder Ali, Deputy Warden</p>
                    <p>
                      ⬣ Dr. T. Gambeeran, Assistant Professor of Tamil</p>
                    <p>
                      ⬣ Mr. E. Praveen, Assistant Professor of English</p>
                    <p>
                      ⬣ Vice-President, Students’ Union</p>
                    <p>
                      ⬣ Chairman, Students’ Union</p>
                    <p>
                      ⬣ Faculty Mentor Concerned (Ad-hoc member)</p>
                    <br></br>
                    <br></br>
                    <h3>NB: The ad hoc member will be called for meetings only when matters under redressal require their presence.</h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/Sc%20ST%20scan%202020-21.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }


            <button onClick={() => setPrincpal(e => !e)} className='tab-open-btn'>✠ MINORITY CELL</button>
            {
              princpal && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF MINORITY CELL</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Mr. Wesley Jayakumar, Assistant Professor of English</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Prof. S.A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>⬣ Dr. V. Kamal Nasir, Vice Principal (Admin)</p>
                    <p>
                      ⬣ Dr. S. Abdul Rasheed, Assistant Professor of Corporate Secretaryship</p>
                    <p>
                      ⬣ Dr. R. Sugaraj Samuel, Assistant Professor of Physics</p>
                    <p>
                      ⬣ Mr. A. Joshua Pravin Kumar, Assistant Professor of English</p>
                    <p>
                      ⬣ Mr. S. Hasan Abdul Cader, Assistant Professor of Computer Applications</p>
                    <p>
                      ⬣ Vice-President, Students’ Union</p>
                    <p>
                      ⬣ Chairman, Students’ Union</p>
                    <p>
                      ⬣ Faculty Mentor Concerned (Ad-hoc member)</p>
                    <br></br>
                    <br></br>
                    <h3>NB: The ad hoc member will be called for meetings only when matters under redressal require their presence.</h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/Minority%20scan%202020-21.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }
            <button onClick={() => setFifth(e => !e)} className='tab-open-btn'>✠ GRIEVANCE REDRESSAL CELL (GRC)</button>
            {
              fifth && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF GRIEVANCE REDRESSAL CELL (GRC)</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Dr. T. Abdul Khadar, Associate Professor of History</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Prof. S.A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>⬣ Dr. V. Kamal Nasir, Vice Principal (Admin)</p>
                    <p>
                      ⬣ Prof. A. R. Abdul Lathif, Controller of Examinations</p>
                    <p>
                      ⬣ Dr. Anvar Sadhath VP, Director, IQAC</p>
                    <p>
                      ⬣ Dr. S. Mohamed Abdul Razak, Dean, Arts</p>
                    <p>
                      ⬣ Dr. M. A. Mohamed Musthafa, Dean, Science</p>
                    <p>
                      ⬣ Mr. K. S. Md. Akmal, Dean, Commerce</p>
                    <p>
                      ⬣ Dr. A. Hyder Ali, Deputy Warden</p>
                    <br></br>
                    <br></br>
                    <h3>Ad-hoc Members</h3>
                    <p>
                      ⬣ Heads of the departments</p>
                    <p>
                      ⬣ Teaching staff association representative</p>
                    <p>
                      ⬣ Non-Teaching staff association representative</p>
                    <p>
                      ⬣ Chairperson of Students’ union</p>
                    <p>
                      ⬣ Representative of research scholars</p>
                    <br></br>
                    <br></br>
                    <h3>NB: The ad hoc member will be called for meetings only when matters under redressal require their presence.</h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/Grievances%20Redressal%20Cell%20scan%202020-21.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }


            <button onClick={() => setSixth(e => !e)} className='tab-open-btn'>✠ OBC CELL</button>
            {
              Sixth && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF OBC CELL</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Dr. S. Shafivulla, Associate Professor of Hindi</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Prof. S.A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>⬣ Dr. V. Kamal Nasir, Vice Principal (Admin)</p>
                    <p>
                      ⬣ Dr. S. Murali, Assistant Professor of Tamil</p>
                    <p>
                      ⬣ Dr. Syed Sajjad Inayath, Assistant Professor of Arabic</p>
                    <p>
                      ⬣ Dr. Gunasekaran V, Assistant Professor of Bank Management</p>
                    <p>
                      ⬣ Vice-President, Students’ Union</p>
                    <p>
                      ⬣ Chairman, Students’ Union</p>
                    <p>
                      ⬣ Faculty Mentor Concerned (Ad-hoc member)</p>
                    <p>
                      ⬣ Mr. M. H. Rasool Mohideen, Superintendent</p>
                    <br></br>
                    <br></br>
                    <h3>NB: The ad hoc member will be called for meetings only when matters under redressal require their presence.</h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/OBC%20scan%202020-21.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }



            <button onClick={() => setSev(e => !e)} className='tab-open-btn'>✠ EQUAL OPPORTUNITY CELL</button>
            {
              sev && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF EQUAL OPPORTUNITY CELL</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Dr. A.K. Sulthan Mohideen, Assistant Professor of Zoology</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Prof. S.A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>⬣ Dr. V. Kamal Nasir, Vice Principal (Admin)</p>
                    <p>
                      ⬣ Dr. B. Afroz Ahmed, Assistant Professor of Commerce</p>
                    <p>
                      ⬣ Mr. M.M. Syed Sulaiman, Assistant Professor of Computer Science</p>
                    <p>
                      ⬣ Mr. J. Asraf Khan, Assistant Professor of Tamil</p>
                    <p>
                      ⬣ Mr. Shak Sayed, Assistant Professor of English </p>
                    <p>
                      ⬣ Ms. J. Jeevitha, Assistant Professor of Criminology </p>
                    <p>
                      ⬣ Vice-President, Students’ Union</p>
                    <p>
                      ⬣ Chairman, Students’ Union</p>
                    <p>
                      ⬣ Mr. B. Noor Mohammed, Office Assistant</p>
                    <br></br>
                    <br></br>
                    <h3>NB: The ad hoc member will be called for meetings only when matters under redressal require their presence.</h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/equal-opportunity-cell-minutes-of-meeting.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }


            <button onClick={() => setEigth(e => !e)} className='tab-open-btn'>✠ ETHICS COMMITTEE</button>
            {
              eigth && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF ETHICS COMMITTEE</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Dr. M. Gulam Mohamed, Dean - Research , Associate Professor of Physics</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Prof. S.A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>⬣ Dr. V. Kamal Nasir, Vice Principal (Admin)</p>
                    <p>
                      ⬣ Dr. Anvar Sadhath Valiyaparambath, Director - IQAC</p>
                    <p>
                      ⬣ Dr. N.M. Ahamed Ibrahim, Associate professor of Arabic</p>
                    <p>
                      ⬣ Dr. Abdul Raheem, Associate Professor of Economics</p>
                    <p>
                      ⬣ Dr. Kalilur Rahiman, Associate Professor of Chemistry</p>
                    <p>
                      ⬣ Dr. A.K. Sulthan Mohideen, Assistant Professor of Zoology</p>
                    <br></br>
                    <br></br>
                    <h3>NB: The ad hoc member will be called for meetings only when matters under redressal require their presence.</h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/minutes-of-ethics-committee.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }

            <button onClick={() => setNine(e => !e)} className='tab-open-btn'>✠ RESEARCH ADVISORY COMMITTEE</button>
            {
              nine && (
                <div >
                  <p></p>
                  <p></p>
                  <h1>COMPOSITION OF RESEARCH ADVISORY COMMITTEE</h1>
                  <div className='tab-para'>
                    <h3>Chairperson</h3>
                    <p>⬣ Dr. S. Basheer Ahamed, Principal</p>
                    <br></br>
                    <br></br>
                    <h3>Coordinator</h3>
                    <p>⬣ Dr. M. Gulam Mohamed, Dean - Research , Associate Professor of Physics</p>
                    <br></br>
                    <br></br>
                    <h3>Members</h3>
                    <p>⬣ Prof. S.A. Sheik Mohamed, Vice Principal (Academic)</p>
                    <p>⬣ Dr. V. Kamal Nasir, Vice Principal (Admin)</p>
                    <p>
                      ⬣ Dr. Anvar Sadhath Valiyaparambath, Director - IQAC</p>
                    <p>
                      ⬣ Dr. N.M. Ahamed Ibrahim, Associate professor of Arabic</p>
                    <p>
                      ⬣ Dr. Abdul Raheem, Associate Professor of Economics</p>
                    <p>
                      ⬣ Dr. Kalilur Rahiman, Associate Professor of Chemistry</p>
                    <p>
                      ⬣ Mr. S.M. Mohamed Lukman, Librarian</p>
                    <p>
                      ⬣ Mr. Abdurahman, Research Scholar, Department of English (Ad-Hoc-Member)*</p>
                    <br></br>
                    <br></br>
                    <h3>NB: <br></br> 1. The ad hoc member will be called for meetings only when matters under redressal require their presence. <br></br> 2. Will be nominated by the principal, once in two years. </h3>
                    <br></br>
                    <br></br>
                    <a href='https://thenewcollege.edu.in/pdf/minutes-of-research-advisory-committee.pdf' style={{ color: "black", textDecoration: "none" }} target='new'>☮ Minutes of the Meeting</a>
                  </div>
                </div>
              )
            }


          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Autonomy;
